class CreateBeneficiaryContact {
	constructor(
		public readonly facilityId: number,
		public readonly beneficiaryId: number,
		public readonly firstName: string,
		public readonly lastName: string,
		public readonly role: string | null,
		public readonly isPersonOfTrust: boolean,
		public readonly roleDetails: string | null,
		public readonly relationship: string,
		public readonly phoneNumber: string | null,
		public readonly email: string | null,
		public readonly notes: string | null,
	) {
		Object.freeze(this);
	}

	// `facilityId` and `beneficiaryId` are route identifiers: neither belongs in the request body.
	toJSON(): Record<string, unknown> {
		return {
			firstName: this.firstName,
			lastName: this.lastName,
			role: this.role,
			isPersonOfTrust: this.isPersonOfTrust,
			roleDetails: this.roleDetails,
			relationship: this.relationship,
			phoneNumber: this.phoneNumber,
			email: this.email,
			notes: this.notes,
		};
	}
}

export default CreateBeneficiaryContact;
